import React from 'react';
import {
  BrowserRouter, Route, Routes, Navigate,
} from 'react-router-dom';

import {
  LOGIN, STATIONS, REPORTS, SETTINGS, FILES, NOTIFICATIONS, USERINFO,
} from 'Features/routePaths';
import Login from 'Features/Login/LoginForm';
import Home from 'Features/Home/Home';

import StationsRouter from 'Features/StationsNew/Router.Stations';
import ReportsRouter from 'Features/Reports/Reports.Router';
import Files from 'Features/FileViewer/FileViewer';
import NotificationsRouter from 'Features/Notifications/Notifications.Router';
import UserInfo from 'Features/UserInfo/UserInfo';
import SettingsRouter from 'Features/Settings/Settings.Router';
import { PrivateNavigate } from './PrivateNavigate';
import Materials from "../Materials/Materials";
import CalculationsRouter from "../Calculations/CalculationsRouter";
import {Monitoring} from "../Monitoring/Monitoring";

// const Login = React.(() => import('Components/Login/LoginForm'));
// const Settings = React.(() => import('Components/Settings/Settings'));
// const Home = React.(() => import('Components/Home/Home'));
// const Stations = React.(() => import('Components/Stations/Stations'));

function AppRouter() {
  console.log(`%c ${process.env.REACT_APP_TITLE}    `, "font-family: 'Impact'; font-weight:bold;font-size:50px;color:#eee;text-shadow:3px 3px 0 #ddd,6px 6px 0 #ccc,9px 9px 0 #bbb,12px 12px 0 #aaa,15px 15px 0 #999,18px 18px 0 #888,21px 21px 0 #777");
  // console.log(`%c СПО ЦСОД    `, "font-family: 'Impact'; font-weight:bold;font-size:50px;color:#eee;text-shadow:3px 3px 0 #ddd,6px 6px 0 #ccc,9px 9px 0 #bbb,12px 12px 0 #aaa,15px 15px 0 #999,18px 18px 0 #888,21px 21px 0 #777");
  return (
    <BrowserRouter>
      <Routes>
        <Route path={LOGIN} element={<Login />} />
        <Route path="*" element={<PrivateNavigate />}>
          <Route path="/" element={<Home />} />

          <Route path={`${STATIONS}/*`} element={<StationsRouter />} />
          <Route path={`${REPORTS}/*`} element={<ReportsRouter />} />
          <Route path={`${SETTINGS}/*`} element={<SettingsRouter />} />
          <Route path="materials/*" element={<Materials />} />
          <Route path="calculations/*" element={<CalculationsRouter />} />
          <Route path={`${FILES}`} element={<Files />} />
          <Route path={`${NOTIFICATIONS}/*`} element={<NotificationsRouter />} />
          <Route path={`${USERINFO}`} element={<UserInfo />} />
          <Route path="monitoring" element={<Monitoring />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default AppRouter;
